import styled from 'styled-components';

interface ContainerProps {
  full: boolean;
}

interface Props {
  active: boolean;
  centerValue: boolean;
}

interface ButtonProps {
  waiting?: boolean;
  active?: boolean;
  themeLess?: boolean;
}

export const Container = styled.div<ContainerProps>`
  min-width: ${(props) => (props.full ? 350 : 80)}px;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.table.header};
  max-height: 400px;
  padding: 15px;
  overflow-y: auto;
  border-radius: 6px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.softGray};
  background-color: ${(props) => props.theme.colors.softGray};
  border: 2px solid ${(props) => props.theme.colors.white};
  font-size: 14px;
  margin-bottom: 10px;

  &:focus {
    background-color: ${(props) => props.theme.colors.white};
    border: 2px solid ${(props) => props.theme.colors.primary};
    outline: none;
  }
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Option = styled.div<Props>`
  height: 40px;
  padding: 10px 8px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.active && props.theme.colors.primary};
  color: ${(props) =>
    props.active ? props.theme.colors.white : props.theme.colors.text};
  justify-content: ${(props) => (props.centerValue ? 'center' : 'flex-start')};

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: ${(props) =>
      props.active
        ? props.theme.colors.primary
        : props.theme.colors.primaryLight};
    color: ${(props) =>
      props.active ? props.theme.colors.white : props.theme.colors.primary};
  }
`;

export const Button = styled.div<ButtonProps>`
  position: relative;
  font-size: 12px;
  font-weight: 600;
  height: 35px;
  min-width: 70px;
  text-align: center;
  width: fit-content;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px 10px;
  border-radius: 5px;
  background-color: ${(props) =>
    props.themeLess ? 'white' : props.theme.colors.table.header};
  color: ${(props) =>
    props.waiting
      ? props.theme.colors.primary
      : props.active
      ? props.theme.colors.primary
      : props.theme.colors.text};
  cursor: pointer;
  align-self: flex-start;
  border: 1px solid
    ${(props) =>
      props.waiting
        ? props.theme.colors.primary
        : props.active
        ? props.theme.colors.primary
        : props.theme.colors.inputBorder};
  word-break: break-all;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
  }
`;
